/* July 2026: synchronize animated GIF banners.
   GIFs start animating the moment each finishes loading, so two banner GIFs drift out of phase.
   Fix: eager-load every visible banner GIF, wait until ALL are fully loaded, then restart them
   in the same frame so their loops begin together. */
(function () {
  function init() {
    var imgs = Array.prototype.filter.call(
      document.querySelectorAll('.banner img, [id*="image_banner"] img, [id*="image-banner"] img'),
      function (img) {
        var src = img.currentSrc || img.src || '';
        return /\.gif($|\?)/i.test(src.split('?')[0] + (/\.gif/i.test(src) ? '.gif' : '')) || /\.gif/i.test(src);
      }
    );
    imgs = imgs.filter(function (img) { return img.offsetParent !== null; });
    if (imgs.length < 2) return;
    imgs.forEach(function (img) { img.loading = 'eager'; img.decoding = 'sync'; });
    Promise.all(imgs.map(function (img) {
      if (img.complete && img.naturalWidth > 0) return Promise.resolve();
      return new Promise(function (res) {
        img.addEventListener('load', res, { once: true });
        img.addEventListener('error', res, { once: true });
      });
    })).then(function () {
      requestAnimationFrame(function () {
        imgs.forEach(function (img) {
          var src = img.currentSrc || img.src;
          if (img.srcset) { img.srcset = ''; }
          if (img.sizes) { img.sizes = ''; }
          img.src = '';
          img.src = src;
        });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
